import { combineReducers } from "redux";
import { TaxDeclarationReducer } from "./TaxDeclaration/Reducer";
import { EmployeeProfileReducer } from "./Profile/Reducer";
import { SalaryStructureReducer } from "./SalaryStructure/Reducer";
import { SalaryComponentReducer } from "./SalaryComponent/Reducer";
import { SalaryComponentTypeReducer } from "./SalaryComponentType/Reducer";
import { ComponentReducer } from "./Component/Reducer";
import { PayrollTemplateReducer } from "./PayRollTemplate/Reducer";
import { EmployeeTemplateReducer } from "./Employee/Reducer";
import { WageReportsReducer } from "./Reports/Reducer";
import { PayDateReducer } from "./PayDate/Reducer";
import { PostAdjustmentReducer } from "./PostAdjustment/Reducer";
import { ExpenseReducer } from "./Expense/Reducer";
import { PayrollManagementReducer } from "./PayrollManagement/Reducer";
import { EcmsConfigFinanceReducer } from "./EcmsComponents/Reducer";
import { EcmsPayrunReducer } from "./PayEcms/Reducer";


const FinanceReducer = combineReducers({
    TaxDeclarationReducer,
    EmployeeProfileReducer,
    SalaryStructureReducer,
    SalaryComponentReducer,
    SalaryComponentTypeReducer,
    ComponentReducer,
    PayrollTemplateReducer,
    EmployeeTemplateReducer,
    WageReportsReducer,
    PayDateReducer,
    PostAdjustmentReducer,
    ExpenseReducer,
    PayrollManagementReducer,
    EcmsConfigFinanceReducer,
    EcmsPayrunReducer
});

export default FinanceReducer;